import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgHide = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M1.304 1.304a1.038 1.038 0 0 1 1.468 0l19.924 19.924a1.038 1.038 0 0 1-1.468 1.468L1.305 2.772a1.038 1.038 0 0 1 0-1.468Z"
      clipRule="evenodd"
    />
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M11.48 10.312a1.063 1.063 0 0 1 0 1.503 1.205 1.205 0 1 0 1.705 1.706 1.064 1.064 0 0 1 1.503 1.504 3.333 3.333 0 0 1-4.711-4.714 1.064 1.064 0 0 1 1.504 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M11.996 6.008a9.572 9.572 0 0 0-2.606.352 1.032 1.032 0 0 1-1.272-.689 1 1 0 0 1 .706-1.241A11.676 11.676 0 0 1 12.002 4c4.881 0 8.825 2.814 11.862 8.002a.981.981 0 0 1 0 .996c-.884 1.511-1.844 2.82-2.883 3.919a1.046 1.046 0 0 1-1.454.055.987.987 0 0 1-.057-1.418c.805-.85 1.576-1.866 2.309-3.054C19.026 8.04 15.758 6.008 12 6.008h-.004Zm-5.034.209a.99.99 0 0 1-.274 1.394c-1.603 1.062-3.099 2.674-4.467 4.89 2.753 4.46 6.021 6.491 9.779 6.491 1.922 0 3.68-.528 5.302-1.596a1.045 1.045 0 0 1 1.428.27.99.99 0 0 1-.277 1.394C16.495 20.348 14.338 21 12 21 7.118 21 3.173 18.186.136 12.998a.983.983 0 0 1 0-.996C1.69 9.346 3.482 7.308 5.533 5.95a1.044 1.044 0 0 1 1.429.267Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgHide);
export default ForwardRef;
